import React from "react";
import { useSnapshot } from "valtio";

import {
    generalConfigStore,
    designStore,
    setActionsButtonsItems,
} from "@store";

import { ActionsButtonsWrapper } from "@components/Common/Design/ActionsButtonsWrapper";

export function ActionsButtons(): JSX.Element {
    const { activePageName } = useSnapshot(designStore);
    const {
        project: {
            template: {
                pages: { ways },
            },
        },
    } = useSnapshot(generalConfigStore);
    const [filteredItems, setFilteredItems] = React.useState<
        ActionsButtonsDesignItemType[]
    >(
        (ways[activePageName] as PageType).actionsButtons.items.filter(
            (item: ActionsButtonsDesignItemType) => {
                const Back_BUTTON_ROLE = 3;
                const ROLES = [Back_BUTTON_ROLE];

                return ROLES.includes(item.role);
            }
        )
    );

    React.useEffect(() => {
        setActionsButtonsItems(filteredItems);
        // eslint-disable-next-line
    }, []);

    return (
        <ActionsButtonsWrapper
            localActionsButtonsItems={filteredItems}
            setLocalActionsButtonsItems={setFilteredItems}
        />
    );
}
